import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Button,
  Card,
  Flex,
  Heading,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiPhone,
  FiSearch,
} from "react-icons/fi";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_order_list } from "../../redux/orderSlice";
import CustomDataCard from "../../components/CustomDataCard";
import { formatCurrency } from "../../utils/utils";
import CustomSingleInput from "../../components/CustomSingleInput";
import CustomButton from "../../components/CustomButton";

const buttonOptions = [
  { label: "Recieved", value: "1", color: "#38A169", colorScheme: "green" },
  { label: "Initiated", value: "2", color: "#ED8936", colorScheme: "orange" },
  { label: "Dispatched", value: "3", color: "#9F7AEA", colorScheme: "purple" },
  { label: "Delivered", value: "4", color: "#4299E1", colorScheme: "blue" },
  { label: "Canceled", value: "5", color: "#FF0000", colorScheme: "red" },
  {
    label: "Rescheduled Orders",
    value: "6",
    color: "#FFC0CB",
    colorScheme: "pink",
  },
];

const Orders = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const [rows, setRows] = useState(5);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const { order_list, total_order_count, report_url } = useSelector(
    (state) => state.orders
  );
  
  // Get the type from location state when returning from order details, otherwise default to "6"
  const [type, setType] = useState(() => {
    return location.state?.returnType || "1";
  });
  
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Clear the location state after using it to prevent issues on subsequent navigations
  useEffect(() => {
    if (location.state?.returnType) {
      // Clear the state by replacing the current history entry
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    store.dispatch(get_order_list({ page: page, rows: rows, type }));
  }, [type]);

  const onPrevious = () => {
    initialValue === 1 || setInitialValue(Number(initialValue) - Number(rows));
    page === 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_order_list({ page: page - 1, rows: rows, type }));
  };

  const onNext = () => {
    rows * page >= total_order_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_order_count || setpage(page + 1);
    rows * page >= total_order_count ||
      store.dispatch(get_order_list({ page: page + 1, rows: rows, type }));
  };

  const createCustomerCardData = (customer) => [
    { key: "Customer Name", value: customer.customer_name },
    { key: "Order ID", value: customer.orderid, iconColor: "green.500" },
    {
      key: "Mobile Number",
      value: customer.mobile,
      icon: FiPhone,
      iconColor: "green.500",
    },
    { key: "Shipping Address", value: customer.shipping_address, maxLines: 3 },
    { key: "Total Amount", value: formatCurrency(customer.totalamount) },
    { key: "Payment Mode", value: customer.paymentmode },
    ...(customer.paymentmode === "PO"
      ? [{ key: "PO Number", value: customer.ponum }]
      : []),
    { key: "Ordered Date", value: customer.datetime },
    { key: "D.P. Name", value: customer.delivery_partner_name },
    { key: "Driver Name", value: customer.driver_name },
    // { key: "Cancel Reason", value: customer.cancel_reason },
    // { key: "Rescheduled Date", value: customer.scheduledate },
    // { key: "Rescheduled Time", value: customer.scheduletime },
     
  ];

  const downloadExcel = async () => {
    try {
      const response = await fetch(report_url, { method: "GET" });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Order_Report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  };

  return (
    <>
      <Card
        bg="#fff"
        p={4}
        flexDir={{ base: "column", md: "row" }}
        gap={3}
        align={{ base: "start", md: "center" }}
      >
        <Heading fontSize="xl">Orders</Heading>

        <Flex
          flexWrap="wrap"
          gap={3}
          w="full"
          justify={{ base: "flex-start", md: "flex-end" }}
        >
          {report_url && (
            <Button
              colorScheme="blue"
              w={{ base: "full", sm: "220px" }}
              onClick={downloadExcel}
            >
              Excel Download
            </Button>
          )}

          <InputGroup
            bg="#f4f5f7"
            borderRadius={5}
            w={{ base: "full", sm: "auto" }}
            maxW="sm"
          >
            <Input placeholder="Search..." />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

      <Card
        bg="#fff"
        p={4}
        flexDir={{ base: "column", md: "row" }}
        gap={3}
        align={{ base: "start", md: "center" }}
      >
        <Flex
          gap={3}
          flexWrap="wrap"
          w="full"
          justify={{ base: "flex-start", md: "space-between" }}
        >
          <Flex align="center" gap={2}>
            <Select
              size="sm"
              w="100px"
              value={rows}
              onChange={(e) => {
                store.dispatch(
                  get_order_list({ page: page, rows: e.target.value, type })
                );
                setRows(e.target.value);
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>

          <InputGroup
            bg="#f4f5f7"
            borderRadius={5}
            w={{ base: "full", sm: "auto" }}
            maxW="sm"
          >
            <Input placeholder="Search..." />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

      <Card p={4}>
        <Wrap spacing={2}>
          {buttonOptions.map((btn) => (
            <WrapItem key={btn.value}>
              <Button
                size="sm"
                variant="outline"
                colorScheme={btn.colorScheme}
                onClick={() => setType(btn.value)}
                backgroundColor={type === btn.value ? btn.color + "60" : ""}
              >
                {btn.label}
              </Button>
            </WrapItem>
          ))}
        </Wrap>

        <HStack gap={2} flexWrap="wrap" mt={3}>
          <CustomSingleInput
            width="200px"
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width="200px"
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
          <CustomButton
            title="Search"
            onClick={() => {
              store.dispatch(
                get_order_list({
                  page: page,
                  rows: rows,
                  type: type,
                  sdate: startDate,
                  edate: endDate,
                })
              );
            }}
          />
        </HStack>
      </Card>

      <SimpleGrid minChildWidth="300px" spacing="10px">
        {order_list?.map((el) => (
          <CustomDataCard
            key={el.id}
            data={createCustomerCardData(el)}
            keyWidth="100px"
            keyColor="gray.700"
            keyWeight="medium"
            valueColor="gray.600"
            valueAlign="left"
            hoverEffect
            showButton
            buttonText="Update Status"
            onButtonClick={() =>
              navigate("/orders/order-detail", { 
                state: { 
                  orderid: el.orderid, 
                  type,
                  // Pass additional context for returning
                  returnTo: "/orders",
                  returnType: type
                } 
              })
            }
            shadow="lg"
          />
        ))}
      </SimpleGrid>

      <Card
        mt={3}
        p={3}
        flexWrap="wrap"
        gap={3}
        flexDir={{ base: "column", sm: "row" }}
        align="center"
        justify="center"
      >
        <FiChevronLeft
          cursor="pointer"
          color={page === 1 ? "gray" : "#007bc9"}
          size={30}
          onClick={onPrevious}
        />
        <Flex gap={2} align="center">
          <Text>{initialValue}</Text>
          <Text>-</Text>
          <Text>
            {rows * page >= total_order_count ? total_order_count : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_order_count}</Text>
        </Flex>
        <FiChevronRight
          cursor="pointer"
          color={rows * page >= total_order_count ? "gray" : "#007bc9"}
          size={30}
          onClick={onNext}
        />
      </Card>
    </>
  );
};

export default Orders;